import { createContext, ReactNode } from 'react';

interface IAccordionContext {
  open: boolean;
  showIcon: boolean;
  onClick: () => void;
}
export const AccordionContext = createContext<IAccordionContext>({
  open: false,
  showIcon: true,
  onClick: () => {},
});

interface IAccordion {
  open: boolean;
  showIcon?: boolean;
  onClick?: () => void;
  className?: string;
  children?: ReactNode;
}

const Accordion = ({
  open,
  showIcon = true,
  onClick = () => {},
  className,
  children,
}: IAccordion) => {
  return (
    <AccordionContext.Provider value={{ open, showIcon, onClick }}>
      <div
        className={`bg-white border-gray-800 flex flex-col items-center w-full ${className}`}
      >
        {children}
      </div>
    </AccordionContext.Provider>
  );
};

export default Accordion;
